<div class="slot" *ngFor="let slot of slots;let i = index" [ngClass]="{ 'disabled':slot.status!='f' }"  kzLib (click)="check($event, i)">
  <div class="check" [ngClass]="{selected:checked[i]}"></div> {{getDate(slot.time)|date:'hh:mm a'}}
  <!-- <span class="sm"> {{getDate(slot.time)|date:'dd'}}</span> -->
</div>
<div class="last">

</div>
